import { SettingConst } from '@faire/web-api--source/types';

/**
 * Whether to use the new filtered component API on the layout service
 */
export const MIGRATE_CATNAV_FILTERED_COMPONENT_API_TO_LAYOUT_250326 =
  'MIGRATE_CATNAV_FILTERED_COMPONENT_API_TO_LAYOUT_250326' as SettingConst<
    'MIGRATE_CATNAV_FILTERED_COMPONENT_API_TO_LAYOUT_250326',
    boolean,
    'RETAILER_ANDROID' | 'RETAILER_IOS' | 'RETAILER' | 'RETAILER_HEAD_TAGS'
  >;
